import React, { useMemo, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { AuthLayout } from '@/components/auth/AuthLayout';
import { getApiBaseUrl } from '@/utils/runtimeApi';
import { formatApiErrorDetail } from '@/utils/authErrors';
import { toast } from 'sonner';

const API = getApiBaseUrl();

export default function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = useMemo(() => searchParams.get('token') || '', [searchParams]);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!token) {
      toast.error('Şifre sıfırlama bağlantısı eksik');
      return;
    }
    if (password !== confirmPassword) {
      toast.error('Şifre tekrarı eşleşmiyor');
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, password }, { withCredentials: true });
      toast.success('Şifreniz güncellendi');
      navigate('/login');
    } catch (error) {
      toast.error(formatApiErrorDetail(error.response?.data?.detail || error.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Yeni Şifre Belirle"
      subtitle="Güvenli sıfırlama bağlantını kullanarak yeni şifreni oluştur."
      footer={<span>Bağlantın yok mu? <Link to="/forgot-password" className="font-medium text-sky-700 underline" data-testid="reset-password-forgot-link">Yeni bağlantı oluştur</Link></span>}
    >
      <form onSubmit={handleSubmit} className="space-y-4" data-testid="reset-password-form">
        <div className="space-y-2">
          <Label htmlFor="reset-password-new">Yeni Şifre</Label>
          <Input id="reset-password-new" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="reset-password-input" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="reset-password-confirm">Yeni Şifre Tekrar</Label>
          <Input id="reset-password-confirm" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required data-testid="reset-password-confirm-input" />
        </div>
        <Button type="submit" className="h-11 w-full" disabled={loading} data-testid="reset-password-submit-button">
          {loading ? 'Şifre güncelleniyor...' : 'Şifreyi Güncelle'}
        </Button>
        {!token ? <p className="rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800" data-testid="reset-password-missing-token-message">Bu sayfa için geçerli bir token gerekiyor. Şifre sıfırlama isteğini yeniden başlat.</p> : null}
      </form>
    </AuthLayout>
  );
}